import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'documents/document';
const model = 'documents/document';
const wizardName = 'Generic File association';
const wizardObject = 'Document';
const wizardAction = 'genericFileAssociation';

const GenericFileAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        save,
        errorMessage,
        errors,
        saving,
        success
    } = useDataProvider(dataProviderName, true);

    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "required": true,
                                "className": "col-12",
                                "icon": "faFile"
                            },
                            "type": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "configuration",
                                        "value": "configuration"
                                    },
                                    {
                                        "label": "singleOfferDocument",
                                        "value": "singleOfferDocument"
                                    },
                                    {
                                        "label": "orderForm",
                                        "value": "orderForm"
                                    },
                                    {
                                        "label": "insurance",
                                        "value": "insurance"
                                    },
                                    {
                                        "label": "mad",
                                        "value": "mad"
                                    },
                                    {
                                        "label": "deliveryReport",
                                        "value": "deliveryReport"
                                    },
                                    {
                                        "label": "returnReport",
                                        "value": "returnReport"
                                    },
                                    {
                                        "label": "bracketMatrix",
                                        "value": "bracketMatrix"
                                    },
                                ],
                                "className": "col-12",
                                "icon": "faCircleX"
                            },
                            "contract": {
                                "type": "relationshipSingle",
                                "relation": {
                                    "drawerRoute": "contracts",
                                    "inverseRelation": "document",
                                    "inverseRelationType": "relationshipSingle"
                                },
                                "view": "contract"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters })
    }

    const contract = discover("contract");
    console.info('Contract renter', contract.renter, contract)
    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                "contract": contract,
                "visibleToDriver": "false",
                "name": t("document") + (contract?.contractIdentifier ? ' ' + contract?.contractIdentifier : '')
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Add a {{wizardObject}} to {{contractIdentifier}}', { wizardObject: wizardObject, contractIdentifier: contract?.contractIdentifier })}
                />
            }
            {...params}
        />
    </>
}

export default GenericFileAssociation;


